import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

const { classNames } = Mobi2Go.helpers;

class MethodSelector extends React.Component {
    static propTypes = {
        method: PropTypes.oneOf(['delivery', 'pickup']).isRequired,
        onChange: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    };

    shouldComponentUpdate = props => {
        const { method } = this.props;
        return props.method !== method;
    };

    render() {
        const { t, method, onChange } = this.props;
        return (
            <div className="m2g-locations-finder-method-selector">
                <span
                    role="button"
                    tabIndex="0"
                    onKeyPress={() => {}}
                    className={classNames(
                        'm2g-locations-finder-method-selector-item',
                        'm2g-touchable',
                        'm2g-button',
                        'm2g-button--checkbox',
                        'm2g-button--left-align',
                        'm2g-button--right-join',
                        {
                            'm2g-button--active': method === 'pickup',
                            'm2g-button--primary': method === 'pickup',
                        }
                    )}
                    style={method === 'pickup' ? { pointerEvents: 'none' } : {}}
                    data-checked={method === 'pickup'}
                    onClick={() => onChange('pickup')}
                >
                    <span className="m2g-locations-finder-method-selector-item-checkbox m2g-icon m2g-icon--checkbox m2g-icon--tick" />
                    <span className="m2g-locations-finder-method-selector-item-label">
                        {t('pickup')}
                    </span>
                </span>
                <span
                    role="button"
                    tabIndex="0"
                    onKeyPress={() => {}}
                    className={classNames(
                        'm2g-locations-finder-method-selector-item',
                        'm2g-touchable',
                        'm2g-button',
                        'm2g-button--checkbox',
                        'm2g-button--left-align',
                        'm2g-button--left-join',
                        {
                            'm2g-button--active': method === 'delivery',
                            'm2g-button--primary': method === 'delivery',
                        }
                    )}
                    style={
                        method === 'delivery' ? { pointerEvents: 'none' } : {}
                    }
                    data-checked={method === 'delivery'}
                    onClick={() => onChange('delivery')}
                >
                    <span className="m2g-locations-finder-method-selector-item-checkbox m2g-icon m2g-icon--checkbox m2g-icon--tick" />
                    <span className="m2g-locations-finder-method-selector-item-label">
                        {t('delivery')}
                    </span>
                </span>
            </div>
        );
    }
}

export default forwardRefWithTranslation('locations.finder')(MethodSelector);
